import { useEffect, useState } from 'react';
import { useCreateLine, getLineWaitTime } from '~/services/queries/line';
import { useRouter } from 'next/router';

import { Footer } from '@getin-widgets/ui';
import { Header, FormQueue, ResponsivenessWrapper } from '~/components';
import { ToastError } from '~/utils/toasts';
import { DOWNLOAD_APP_LINK_LINE } from '@getin-widgets/shared/utils/constants';

import { LineProps } from './types';

import * as S from './styles';
import { PriorityModal } from '~/components/PriorityModal';
import { Spinner } from 'styled-icons/fa-solid';

export const Line = ({
  qrCodeSettingsData,
  unitData,
  isQrCodeGeneric,
  canSeeBirthDateField,
  canSeeEmailField,
}: LineProps) => {
  const router = useRouter();
  const [waitTimeValue, setWaitTimeValue] = useState<number | null>(null);
  const [loadingLineWait, setLoadingLineWait] = useState(false);
  const [isLoadingTypeQrCode, setIsLoadingTypeQrCode] = useState(true);
  const [priorityModalIsOpen, setPriorityModalIsOpen] = useState(true);

  useEffect(() => {
    typeof isQrCodeGeneric === 'boolean' && setIsLoadingTypeQrCode(false);
  }, [isQrCodeGeneric]);

  useEffect(() => {
    if (qrCodeSettingsData) {
      setPriorityModalIsOpen(qrCodeSettingsData.qr_code_priority_modal_enabled);
    }
  }, [qrCodeSettingsData]);

  const CreateLineResponse = useCreateLine({
    onSuccess: (data) => router.push(data.data.trackingUrl),
    onError: (data) => ToastError((data.response?.data as any).message),
  });

  const handleSubmitForm = (values: {
    name: string;
    mobile: string;
    email: string;
    people: number;
    accepted_marketing_agreement: boolean;
  }) => {
    qrCodeSettingsData?.qr_code_enabled
      ? CreateLineResponse.mutate({
          params: {
            ...values,
            metadata: {
              partners: {
                accepted_marketing_agreement:
                  values.accepted_marketing_agreement,
              },
            },
          },
          unit_id: unitData?.id as string,
        })
      : ToastError('Esse QR Code está desabilitado');
  };

  const handleGetWaitLineTime = async (values: { people: number }) => {
    setLoadingLineWait(true);
    const { data, status } = await getLineWaitTime({
      unit_id: unitData?.id as string,
      line_position: (qrCodeSettingsData?.tables_in_line as number) + 1,
      people: values.people,
    });

    status === 200 &&
      !!data?.wait_time_in_minutes &&
      setWaitTimeValue(data?.wait_time_in_minutes[0]);
    setLoadingLineWait(false);
  };

  return (
    <ResponsivenessWrapper>
      {isLoadingTypeQrCode ? (
        <S.LoadingWrapper>
          <S.LoadingContent>
            <Spinner size={30} />
            <span>Buscando informações</span>
          </S.LoadingContent>
          <Footer linkDownload={DOWNLOAD_APP_LINK_LINE} />
        </S.LoadingWrapper>
      ) : (
        <>
          <S.FormContent>
            <PriorityModal
              isModalVisible={priorityModalIsOpen}
              setIsModalVisible={setPriorityModalIsOpen}
            />
            <Header
              unitId={unitData?.id as string}
              unitName={unitData?.name as string}
              tablesInLine={qrCodeSettingsData?.tables_in_line as number}
              loadingWaitTimeLine={loadingLineWait}
              waitTimeLine={waitTimeValue}
              isQrCodeGeneric={isQrCodeGeneric}
            />
            <FormQueue
              tablePeople={qrCodeSettingsData?.table_people as number[]}
              prohibitedTerms={qrCodeSettingsData?.version || []}
              loading={CreateLineResponse.isPending}
              isQrCodeGeneric={isQrCodeGeneric}
              canSeeBirthDateField={canSeeBirthDateField}
              canSeeEmailField={canSeeEmailField}
              getWaitLineTime={handleGetWaitLineTime}
              submit={handleSubmitForm}
            />
          </S.FormContent>
          <Footer linkDownload={DOWNLOAD_APP_LINK_LINE} />
        </>
      )}
    </ResponsivenessWrapper>
  );
};
